module.exports = __webpack_public_path__ + "img/nav.098b6714.svg";